import React from "react";
import {Badge} from "@/components/ui/badge";
import {ClipboardList} from 'lucide-react';
import useCart from "@/hooks/useCart";
import { useT } from "@/lib/config/useTranslations";
import { useLanguage } from "@/lib/config/useLanguage";

export default function BtnCart() {
    const {totalQuantity} = useCart();
    const { t } = useT();
    const { localizePath } = useLanguage();
    const label = t('common.cart');

    return (
        <a
            href={localizePath('/shop/cart')}
            aria-label={label}
            className="rounded-xl flex flex-row items-center gap-2 bg-white/10 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-white/20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white relative"
        >
            <div className="relative inline-block" aria-hidden="true">
                <ClipboardList className="text-white"/>
                {totalQuantity > 0 && (
                    <Badge className="absolute -top-2 -right-2 h-5 min-w-5 flex items-center justify-center px-1 text-xs bg-blue-600 text-white ring-2 ring-white">
                        {totalQuantity}
                    </Badge>
                )}
            </div>

            <span className="sr-only">{label}</span>
        </a>
    )
}
